import { styled } from '@mui/system';
import { Box, Typography, Link } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  border: '1px solid #8C8C8C',
  borderRadius: '8px',
  // padding: theme.spacing(11.75, 8.5, 5),
  padding: theme.spacing(8.5, 8.5, 5),
  width: '100%',
  maxWidth: '764px',
}));

export const StyledLink = styled(Link)(({  }) => ({
  color: '#FF4343',
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: 500,
  textDecoration: 'underline',
  '&:hover': { textDecoration: 'none' },
}));

export const FooterText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(8),
  color: '#3A3A3A',
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 400,
  textAlign: 'center',
}));
